export default __webpack_public_path__ + "static/media/martinize_elastic.42932657.png";